<template lang="pug">
.leftmenu.menuscroll(
   v-if="isOpened"
   @click.stop=""
  )
  e-perfect-scrollbar
    .leftmenu__header
      span {{$translate('Меню')}}
      .leftmenu__close(@click="closeMenu")
        img(src="../../assets/img/icon-menu-close.png")
    .leftmenu__routes
      div(
        v-if="hasMenuItems"
        v-for="item, itemIndex in acceptedMenuItems"
      ).leftmenu__route.leftmenu__nav
        ul
          li(
            @click="closeMenu"
          ).item-menu
            menu-link(
              :menuItem="item"
            )
              span.number {{ item.number || 0}}
              span.text {{$translate(item.title) || ' - '}}
            div(
              v-if="item.childs"
            ).leftmenu__childs
              menu-link(
              v-for="child, childIndex in item.childs"
              :menuItem="child"
              :key="`${itemIndex}_${childIndex}`"
              )
      div(v-if="!hasMenuItems")
        p {{$translate('Нет доступных для просмотра разделов')}}

</template>

<script>
  import {menuApi} from '../../api/api-endpoints.js';
  import {append} from "./model";
  import menu from './utils/menu'
  import MenuLink from "./menu-link"
  import {menuMixin} from "./mixins/menu-mixin"

  export default {
    name: 'left-menu',
    mixins: [menuMixin],
    components: {MenuLink},
    data() {
      return {
        leftMenu: []
      }
    },
    computed: {
      menuItems () {
        const leftMenu = menu.getMenuItemsForCurrentRegion();
        return append(leftMenu,this.leftMenu);
      },
    },
    created () {
      window.addEventListener('click', this.outerClick);
      if(this.isAuth) {
        this.menuList(menuApi.list()).then(({data}) => this.leftMenu = data);
      }
      this.closeMenu()
    },
    destroyed () {
      window.removeEventListener('click', this.outerClick);
      this.closeMenu()
    }
  }
</script>
